import React, { useEffect } from 'react';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { OverlayProvider } from '@uhg-abyss/web/ui/OverlayProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import NavigationBar from '@src/generic-components/NavigationBar';
import { preloadCommonModules } from '@src/utility/moduleLoader';

const theme: any = createTheme('uhc', {
	deprecatedFont: true,
});
theme.themeVariantFonts();

export const HamMenu = () => {
	useEffect(() => {
		preloadCommonModules();
		window.dispatchEvent(new CustomEvent('parcelLoad'));
	}, []);

	return (
		<ThemeProvider theme={theme} includeBaseCss={false}>
			<OverlayProvider>
				<NavigationBar />
			</OverlayProvider>
		</ThemeProvider>
	);
};

